import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";
import ACHParticipantsRow from "../ACHParticipantsRow";

/**
 * @function ACHParticipantsTable
 * @return {React.Component}
 * @exported true
 * @description This is the main table view for ACH Participants modal.
 */
export default function ACHParticipantsTable(props) {
    const participants = props.participants ?? [];
    const onParticipantRowChange = props.onParticipantRowChange ?? (() => {});
    const onSelectAllParticipantsCheckboxChange = props.onSelectAllParticipantsCheckboxChange ?? (() => {});
    const allParticipantsAreSelected =participants.length >0 && participants.filter(item => item.isSelected === "true").length === participants.length;

    const rows = participants.length !== 0 ?participants.reduce((acc, item) => {
        acc.push(
            <ACHParticipantsRow key={ item.id } dataPoint={ `ACH_Participants_Modal_Participant_Row_${ item.id }` } participant={ item } onParticipantRowChange={ onParticipantRowChange } />
        );
        return acc;
    }, []):
    <TableItemContainer className="no-participant-row">
    <td colSpan={9} className="text-center table-item-text-view">There are no participants.</td>
  </TableItemContainer>

    return (
        <TableView className="ach-participants-table">
            <TableColumnContainer className="one-time-ach-from-header">

                <TableItemView className="checkbox-col">
                    <UICheckbox label="" value={ allParticipantsAreSelected } dataPoint={ `ACH_Participants_Modal_All_Participants_Selected` } onChange={ onSelectAllParticipantsCheckboxChange } />
                </TableItemView>
                <TableItemView lassName="nickname-col" >
                    <span className="flex-container align-center">
                        <span className="set-width">Nickname</span>
                        <DisabledPrompt>
                            <SVGAsset id="ArrowUpIcon" className="sort-icon clickable" />
                        </DisabledPrompt>
                    </span>
                </TableItemView>
                <TableItemTextView className="unique-identifier-col" text="Unique Identifier" />
                <TableItemTextView className="created-col" text="Created" />
                <TableItemTextView className="group-col" text="Group" dataPoint="Group_Column_Header"/>
                <TableItemTextView className="account-number-col" text="Account Number" />
                <TableItemTextView className="routing-number-col" text="Routing Number" />
                <TableItemTextView className="account-type-col" text="Account Type" />
                <TableItemTextView className="status-col" text="Status" />
            </TableColumnContainer>
            <TableBody>{ rows }</TableBody>
        </TableView>
    )
}
